import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import { StarRating } from '../star-rating';
import { STAR_RATING_SECTION } from './index';
import * as styles from './average-star-rating-and-total.style';

interface StarRatingDisplayProps {
  rating: number;
  fillStar?: string;
  starSize: number;
  starGap: number;
  section: STAR_RATING_SECTION;
  testIdPrefix?: string;
}

const StarRatingDisplay: React.FC<StarRatingDisplayProps> = ({
  rating,
  fillStar,
  starSize,
  starGap,
  section,
  testIdPrefix = '',
}) => (
  <StackItem css={styles.starRating(section)} align="center">
    <StarRating
      rating={rating}
      maxRating={1}
      fillStar={fillStar}
      starSize={starSize}
      starGap={starGap}
      data-testid={`${testIdPrefix}average-rating-stars`}
    />
  </StackItem>
);

export default StarRatingDisplay;
